import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'equine-ui-nx-order-detail-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-detail-table.component.html',
  styleUrl: './order-detail-table.component.scss',
})
export class OrderDetailTableComponent {

  @Input() details!: { succeeded: boolean, items: {label: string, value: string}[] };


}
